// Filename: public/md5.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

export function add(param1, param2) {
	return param1 + param2;
}


// The following code demonstrates how to call the add
// function from your site's page code or site code.

/* 
import {add} from 'public/utils.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/


//The following code demonstrates how to call the add 
//function in one of your site's backend files.

/* 
import {add} from 'public/md5.js'

export function usingFunctionFromPublic(a, b) {
	return add(a,b);
}
*/

export function encrypt(value) 
{
  var result="";
  for(var i=0;i<value.length;i++)
  {
    if(i<value.length-1)
    {
        result+=value.charCodeAt(i)+10;
        result+="-";
    }
    else
    {
        result+=value.charCodeAt(i)+10;
    }
  }
  return result;
}
export function decrypt(value)
{
  var result="";
  var array = value.split("-");

  for(var i=0;i<array.length;i++)
  {
    result+=String.fromCharCode(array[i]-10);
  }
  return result;
} 